// Configuration Docs: http://zuppler.github.io/online-ordering/2-features-configuration.html
import React from 'react';
import { getBaseUrl } from './ZupplerMenu.utils';
import DynamicScript from '../DynamicScript/DynamicScript';
import './ZupplerMenu.css';
var defaultProps = {
  isMultipleRestaurant: false,
  dataIntegration: '',
  dataRestaurantId: '',
  dataPortalSlices: '',
  dataLocale: ''
};
export default function ZupplerMenu(_ref) {
  var dataChannelUrl = _ref.dataChannelUrl,
    dataIntegration = _ref.dataIntegration,
    dataRestaurantId = _ref.dataRestaurantId,
    dataLocale = _ref.dataLocale,
    dataPortalSlices = _ref.dataPortalSlices,
    isMultipleRestaurant = _ref.isMultipleRestaurant;
  var baseUrl = getBaseUrl();
  var commonScriptURL = "".concat(baseUrl, "/common.js");
  var portalScriptURL = "".concat(baseUrl, "/portal.js");
  var orderScriptURL = "".concat(baseUrl, "/order.js");
  if (isMultipleRestaurant) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DynamicScript, {
      src: commonScriptURL
    }), /*#__PURE__*/React.createElement(DynamicScript, {
      src: portalScriptURL
    }), /*#__PURE__*/React.createElement("div", {
      id: "zuppler-menu",
      "data-channel-url": dataChannelUrl,
      "data-locale": dataLocale,
      "data-portal-slices": dataPortalSlices
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DynamicScript, {
    src: commonScriptURL
  }), /*#__PURE__*/React.createElement(DynamicScript, {
    src: orderScriptURL
  }), /*#__PURE__*/React.createElement("div", {
    id: "zuppler-menu",
    "data-integration": dataIntegration,
    "data-restaurant-id": dataRestaurantId,
    "data-channel-url": dataChannelUrl
  }));
}
ZupplerMenu.defaultProps = defaultProps;